<template>
  <div class="section-main__warp building-page">
    <div class="right-content">
      <div class="header-contnet">
        <el-button type="primary" v-auth="'/building/index:add'" @click="handleOpenPanel" icon="el-icon-plus">
          新增
        </el-button>
      </div>
      <div class="main-content">
        <div class="data-content" v-if="!loading">
          <!-- 查询结果 -->
          <div v-if="listData && listData.length" class="list-content">
            <el-scrollbar>
              <div style="display: flex; flex-wrap: wrap">
                <div v-for="(item, index) in listData" :key="index" class="list-item">
                  <div class="imgDiv">
                    <!-- left -->
                    <div class="itemLeft">
                      <img :src="imgPath(item)" class="image" @click="showViewer($event)"
                        onerror="this.src='/images/theme/newDark/default.png'" />
                    </div>
                    <div class="itemRight" @click="handleUpdate(item, 'view')">
                      <div class="itemName">
                        <span :title="item.buildingName">{{
                          item.buildingName
                        }}</span>
                        <i v-auth="'/building/index:delete'" class="el-icon-delete" style="
                            position: absolute;
                            right: 24px;
                            top: 24px;
                            font-size: 14px;
                            cursor: pointer;
                          " @click.stop="deleteClick(item)"></i>
                      </div>
                      <div>
                        <div class="itemItem">
                          <img src="../../../common/assets/images/floor.png" />
                          <span>{{ item.floorSize + "层" || "无" }}</span>
                        </div>
                        <div class="itemItem">
                          <img src="../../../common/assets/images/person.png" />
                          <span>{{ item.buildingPersonnelName || "无" }}</span>
                        </div>
                        <div class="itemItem">
                          <img src="../../../common/assets/images/telephone.png" />
                          <span>{{ item.buildingPersonnelPhone || "无" }}</span>
                        </div>
                      </div>
                      <div class="" style="
                          padding-left: 20px;
                          margin-top: 12px;
                          white-space: pre;
                        ">
                        <el-button type="info" @click.stop="showFloor(item)">楼层</el-button>
                        <el-button type="info" v-auth="'/building/index:update'"
                          @click.stop="handleUpdate(item, 'edit')">修改</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <!-- 暂无数据 -->
          <dataEmpty v-else />
        </div>
        <div class="loading-content" v-loading="true" style="line-height: 300px" v-else></div>
      </div>
      <!-- 有数据时的页码 -->
      <div class="page-content paging" :style="!listData.length">
        <el-pagination background :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pageObj.pageSize"
          @current-change="currentChange" @size-change="sizeChange" layout="total, sizes, prev, pager, next, jumper"
          :total="pageObj.total">
        </el-pagination>
      </div>
    </div>

    <!--新增修改 面板 -->
    <appPanel :width="700" class="app-panel" :isExpand="showPanel" @cancel="handleClosePanel" :title="formState === 1
      ? '新增楼栋信息'
      : formState === 2
        ? '编辑楼栋信息'
        : '楼栋详情'
      ">
      <el-scrollbar>
        <el-form :inline="true" ref="ruleForm" label-width="97px" :model="formData"
          style="width: calc(100% - 10px); position: relative" :rules="rules">
          <div class="flex-row valign-center" style="width: 100%">
            <div style="width: 92%">
              <el-form-item label="楼栋名称" prop="buildingName">
                <el-input v-model="formData.buildingName" :readonly="formState == 3" :maxlength="64"
                  placeholder="请输入名称"></el-input>
              </el-form-item>
              <el-form-item label="消防负责人" prop="firefightingPersonnelName">
                <el-input autosize readonly clearable placeholder="请选择负责人" :value="formData.firefightingPersonnelName">
                </el-input>
                <img style="
                    cursor: pointer;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                  " src="@src/common/assets/images/icon/more.png" @click="selectPerson" v-if="formState != 3" alt="" />
              </el-form-item>
              <el-form-item label="值班座机" prop="officePhone">
                <el-input type="textarea" autosize :resize="formState == 3 ? 'none' : ''" :readonly="formState == 3"
                  clearable placeholder="请输入电话号码，多个号码用','分开" v-model="formData.officePhone"></el-input>
              </el-form-item>
            </div>
            <el-form-item prop="fileList" label-width="0" style="width: 180px; padding-left: 16px; margin-top: 10px">
              <el-upload action v-if="!fileList.length && formState !== 3" :file-list="fileList" ref="addRosterUl"
                :show-file-list="false" :list-type="'picture-card'" accept="image/png, image/jpg, image/jpeg, image/bpm"
                :auto-upload="false" :multiple="false" :limit="1" :on-change="onChangeFile" :on-remove="onRemoveFile">
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="imgFile" v-else>
                <img :src="imageUrl" @click="showViewer($event)" class="image-file"
                  style="height: 135px; width: 135px; cursor: pointer"
                  onerror="this.src='/images/theme/newDark/default.png'" />
                <!-- onerror="this.src='/images/theme/newDark/default.png'" -->
                <div class="delete-icon" v-if="formState != 3">
                  <i class="el-icon-delete" @click="onRemoveFile"></i>
                </div>
              </div>
            </el-form-item>
          </div>
          <div style="width: 100%">
            <el-form-item label="楼栋经纬度">
              <el-col :span="11">
                <el-input readonly :value="formData.lat" :placeholder="formData.lat ? formData.lat : '请选择楼栋经纬度'
                  ">
                </el-input>
              </el-col>
              <el-col :span="2" style="text-align: center">--</el-col>
              <el-col :span="11">
                <el-input readonly :value="formData.lng" :placeholder="formData.lat ? formData.lng : '请选择楼栋经纬度'
                  ">
                </el-input>
              </el-col>

              <el-button type="text" size="small" class="iconfont icon-position map-choose" @click="openMap"></el-button>
            </el-form-item>
            <el-form-item label="楼栋管理人" prop="buildingPersonnelName">
              <el-col :span="11">
                <el-input v-model="formData.buildingPersonnelName" readonly placeholder="请选择楼栋管理人"></el-input>
              </el-col>
              <el-col :span="2" style="text-align: center">--</el-col>
              <el-col :span="11">
                <el-input v-model="formData.buildingPersonnelPhone" readonly placeholder="请选择楼栋管理人"></el-input>
                <img style="
                    cursor: pointer;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                  " src="@src/common/assets/images/icon/more.png" @click="openPeople('1', 'buildingPersonnelName')"
                  v-if="formState != 3" alt="" />
              </el-col>
            </el-form-item>
            <el-form-item label="楼栋安全员" prop="securityPersonnelList" style="width: 100%">
              <el-input type="textarea" :resize="formState == 3 ? 'none' : ''" autosize readonly placeholder="请选择楼栋安全员"
                :value="formData.securityPersonnelList
                  .map((el) => {
                    return el.name + '【' + el.phone + '】';
                  })
                  .join(',')
                  "></el-input>

              <img style="
                  cursor: pointer;
                  position: absolute;
                  top: 10px;
                  right: 10px;
                " src="@src/common/assets/images/icon/more.png" @click="openPeople('2', 'securityPersonnelList')"
                v-if="formState != 3" alt="" />
            </el-form-item>

            <el-form-item label="安全员备用联系人" prop="alternatePersonnelList" style="width: 100%">
              <el-input type="textarea" readonly :rows="3" :resize="formState == 3 ? 'none' : ''" placeholder="请选择备用联系人"
                :value="formData.alternatePersonnelList
                  .map((el) => {
                    return el.name + '【' + el.phone + '】';
                  })
                  .join(',')
                  "></el-input>
              <img style="
                  cursor: pointer;
                  position: absolute;
                  top: 10px;
                  right: 10px;
                " src="@src/common/assets/images/icon/more.png" @click="openPeople('2', 'alternatePersonnelList')"
                v-if="formState != 3" alt="" />
            </el-form-item>
          </div>
        </el-form>
        <div style="position: absolute; bottom: 0px; right: 0px;">
          <el-button @click="handleClosePanel" type="info" :loading="subBtm">
            {{ subBtm ? "提交中" : formState != 3 ? "取消" : "关闭" }}
          </el-button>
          <el-button type="primary" v-if="formState != 3" :loading="subBtm" @click="submitClick">
            {{ subBtm ? "提交中" : "确定" }}
          </el-button>
        </div>
      </el-scrollbar>
    </appPanel>
    <appPanel :width="700" class="app-panel" :isExpand="floorShow" @cancel="closeFloor"
      :title="floorForm.buildingName + '-楼层信息'">
      <floor ref="refFloor" @update-callback="getListData"></floor>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFloor" type="info"> 关闭 </el-button>
      </span>
    </appPanel>
    <!-- 消防人员选择弹框 -->
    <el-dialog title="人员选择" :visible.sync="linkDialog" v-dialogDrag width="56%" class="choose-container">
      <ioc-table ref="personTable" :key="fireKey" :data="accountData" :option="accountOption" :page="accountPage"
        @size-change="personChangeSize" @current-change="currentAccountChange" @search-change="searchList"
        @search-reset="personReset" @radio-change="personRadio">
      </ioc-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelChoose">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </span>
    </el-dialog>
    <!-- 引入gis地图 -->
    <app-panel isScreen @screen="handleScreen" :isExpand="showMap" @cancel="mapCancleOpt"
      :title="formState == 3 ? '查看位置' : '选择位置'">
      <div style="width: 100%; height: calc(100% - 0px)">
        <appMap ref="refAppMap" class="map" divId="miniMap"></appMap>
      </div>
      <!-- 底部操作按钮 -->
      <span slot="footer" v-if="formState != 3" class="dialog-footer">
        <el-button type="info" @click="mapCancleOpt">取消</el-button>
        <el-button type="primary" @click="mapConfirmOpt">确定</el-button>
      </span>
    </app-panel>
    <!-- <el-dialog
      :title="formState == 3 ? '查看位置' : '选择位置'"
      width="60%"
      :visible.sync="showMap"
      :modal="false"
      :before-close="mapCancleOpt"
    >
    </el-dialog> -->
    <!-- 人员选择 -->
    <changePeople @confirmCallBack="confirmCallBack" ref="selectPeople" :key="key" :checkType="checkType" />
  </div>
</template>

<script>
import appMap from "@src/components/common/gis/index";
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Bus, Dates } from "$utils";
import i18n from "@src/common/lib/i18n";
import dataEmpty from "@src/components/common/ioc-component/app-data-empty.vue";
import changePeople from "../components/changePeople.vue";
import floor from "../components/floor.vue";
import accountOption from "../const/accountOptions";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    dataEmpty,
    appPanel,
    changePeople,
    floor,
    appMap,
  },
  filters: {
    cradTypeFilter(el) {
      return Dic.findByValue("SENU028", el) || i18n.t("personMg.label.IDNo");
    },
    sexFilter(el) {
      return Dic.findByValue("SENU062", el);
    },
  },
  data() {
    return {
      floorShow: false,
      floorForm: {},
      showPanel2: false,
      linkDialog: false,
      accountData: [],
      accountPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      // 账户Id
      accountId: "",
      accountSearch: {},
      accountOption: accountOption(),
      workGroupCode: "", //安保工作组code
      subBtm: false,
      key: 0,
      fireKey: 0,
      checkType: "select", //radio多选
      showMap: false,
      personInfoList: [],
      personTypeVisible: false,
      searchData: {
        name: "",
        sex: "",
        num: "",
        date: "",
      },
      fileList: [], // 上传图片数组
      formList: [], // 名单表单名单组
      pageObj: {
        // 分页数据
        pageNum: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        total: 0,
      },
      formState: 1, // 1：新增 2：修改
      showPanel: false, // 新增修改弹窗
      // 查询结果
      listData: [],
      filterData: {
        name: "",
      },
      // 新增修改表单数据
      formData: {
        belongModelUrl: "", //模型链接
        mapModelUrl: "", //地图模型链接
        buildingCode: "", //楼栋code
        buildingName: "", //楼栋名称
        buildingPersonnelCode: "", //管理人code
        buildingPersonnelName: "", //管理人姓名
        buildingPersonnelPhone: "", //管理人手机
        securityPersonnelList: [], //安全人
        officePhone: "", //值班室电话
        firefightingPersonnelCode: "", //消防小组负责人code
        firefightingPersonnelName: "", //消防小组负责人姓名
        alternatePersonnelList: [], //备用安全员
        fileList: [],
        lat: "",
        lng: "",
      },
      PersonnelList: [],
      rules: {
        buildingName: [
          { required: true, message: "请输入楼栋名称" },
          { max: 100, message: "长度10个字符", trigger: "blur" },
        ],
        // firefightingPersonnelName: [
        //   {
        //     required: true,
        //     message: "请选择消防负责人",
        //     trigger: "change",
        //   },
        // ],
        buildingPersonnelName: [
          { required: true, message: "请选择管理员", trigger: "blur,change" },
        ],
        // phone: [
        //   {
        //     pattern: /(^(([0\\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$)|(^((\d{2,3}-))?0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/,
        //     message: this.$t('personMg.message.PleaseNumberRight'),
        //     trigger: 'blur',
        //   },
        // ],
      },
      isIndeterminate: false,
      checkAll: false,
      listCodes: [], // 选中名单数组
      loading: false,
      point: {},
      indexLabel: "",
      imageUrl: "",
      checkFirePeople: null,
    };
  },
  watch: {
    fileList: {
      handler(newValue, oldValue) {
        this.formData.fileList = newValue;
      },
      deep: true,
    },
    showPanel: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.floorShow = false;
        }
      },
    },
    floorShow: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.showPanel = false;
        }
      },
    },
  },
  mounted() {
    this.getListData();
  },
  methods: {
    handleScreen() {
      this.$refs.refAppMap.refreshMap();
    },
    personRadio(item) {
      this.checkFirePeople = item;
    },
    showFloor(info) {
      this.floorForm = JSON.parse(JSON.stringify(info));
      this.$refs.refFloor.getListData(info);
      this.handleSwitchPanel("floorShow", "closeFloor");
    },
    closeFloor() {
      this.floorShow = false;
    },
    onChangeFile(file, fileList) {
      if (!this.validImg(file)) {
        this.imageUrl = "";
        this.fileList = [];
        return false;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      this.fileList = fileList;
    },
    onRemoveFile(file, fileList) {
      this.$confirm("确认要删除图片吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.imageUrl = "";
        this.fileList = [];
      });
    },
    //选择消防人员
    selectPerson() {
      this.linkDialog = true;
      this.$nextTick(() => {
        this.fireKey += 1;
        this.getAccountList();
      });
    },
    // 获取人员选择弹框中人员列表
    getAccountList() {
      const params = {};
      // params.accountType = 1;
      params.nickName = this.accountSearch.nickName;
      params.accountNumber = this.accountSearch.accountNumber;
      params.pageNo = this.accountPage.pageNum;
      params.pageSize = this.accountPage.pageSize;
      this.$fetch(api.queryAccouts, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        if (this.accountId) {
          this.$refs.personTable.templateRadio = "";
          if (this.formData.firefightingPersonnelName)
            response.returnObj.list.forEach((el, index) => {
              if (el.accountNumber == this.accountId) {
                this.$refs.personTable.templateRadio = index;
              }
            });
        }

        this.accountData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.accountPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },

    // 消防人员选择确认弹框
    confirmChoose() {
      if (!this.checkFirePeople) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择人员",
        });
        return;
      }
      this.formData.firefightingPersonnelName = this.checkFirePeople.nickName;
      this.formData.firefightingPersonnelCode =
        this.checkFirePeople.accountNumber;
      this.accountId = this.checkFirePeople.accountNumber;
      this.linkDialog = false;
    },
    cancelChoose() {
      this.linkDialog = false;
      this.checkFirePeople = null;
    },
    // 员工弹框修改每页数据数量
    personChangeSize(val) {
      this.accountPage.pageNum = 1;
      this.accountPage.pageSize = val;
      this.getAccountList();
    },
    currentAccountChange(val) {
      this.accountPage.pageNum = val;
      this.getAccountList();
    },
    searchList(param) {
      this.accountSearch = Object.assign(param);
      this.accountPage.pageNum = 1;
      this.getAccountList();
    },
    personReset() {
      this.getAccountList();
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.securityWorkGroupCode;
          entity.name = item.securityWorkGroupName;
          entity.appointmentCarNotifyFlag = item.appointmentCarNotifyFlag;
          entity.appointmentNoCarNotifyFlag = item.appointmentNoCarNotifyFlag;
          entity.leaderCode = item.securityWorkGroupLeader;
          entity.leaderName = item.leaderName;
          entity.parentCode = item.parentCode;
          entity.areaDevGroupCodeList = item.areaDevGroupCodeList;
          entity.isLeaf = !item.hasLeaf || !item.securityWorkGroupChildren;
          if (item.securityWorkGroupChildren) {
            entity.children = self.menusDataPro(item.securityWorkGroupChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    openPeople(type, label) {
      this.indexLabel = label;
      this.key += 1;
      if (type == "1") {
        this.checkType = "radio";
      } else {
        this.checkType = "select";
      }
      this.$nextTick(() => {
        if (this.indexLabel == "buildingPersonnelName") {
          this.$refs.selectPeople.open(
            this.formData.buildingPersonnelCode && [
              {
                name: this.formData.buildingPersonnelName,
                personnelCode: this.formData.buildingPersonnelCode,
                phone: this.formData.buildingPersonnelPhone,
              },
            ],
            "radio"
          );
        } else if (this.indexLabel == "firefightingPersonnelName") {
          this.$refs.selectPeople.open(
            this.formData.firefightingPersonnelCode && [
              {
                name: this.formData.firefightingPersonnelName,
                personnelCode: this.formData.firefightingPersonnelCode,
                phone: this.formData.firefightingPersonnelPhone,
              },
            ],
            "radio"
          );
        } else {
          // 多选
          this.$refs.selectPeople.open(
            this.formData[this.indexLabel],
            "select"
          );
        }
        // this.$refs.selectPeople.open(this.formData.securityPersonnelList)
      });
    },
    // 人员选择回调
    confirmCallBack(data) {
      this.$refs.ruleForm.clearValidate(this.indexLabel);
      if (this.checkType == "radio") {
        if (this.indexLabel == "buildingPersonnelName") {
          (this.formData.buildingPersonnelCode = data[0].personnelCode),
            (this.formData.buildingPersonnelName = data[0].name),
            (this.formData.buildingPersonnelPhone = data[0].phone);
        } else if (this.indexLabel == "firefightingPersonnelName") {
          (this.formData.firefightingPersonnelCode = data[0].personnelCode),
            (this.formData.firefightingPersonnelName = data[0].name),
            (this.formData.firefightingPersonnelPhone = data[0].phone);
        }
      } else {
        // this.formData.securityPersonnelList = [...data]
        this.formData[this.indexLabel] = [...data];
      }
    },
    // 点击地图框中的取消操作
    mapCancleOpt() {
      this.point = [];
      this.$refs.refAppMap.removePoint("buildingManage");
      this.showMap = false;
    },
    mapConfirmOpt() {
      this.formData.lng = Number(this.point[0]).toFixed(10);
      this.formData.lat = Number(this.point[1]).toFixed(10);
      this.$refs.refAppMap.removePoint("buildingManage");
      this.showMap = false;
    },
    initMap() {
      if (this.formState != 3) {
        this.$refs.refAppMap.getLocation(this.getLocationCB);
      }
      if (this.formData.lng) {
        let coord = [Number(this.formData.lng), Number(this.formData.lat)];
        this.$refs.refAppMap.setMapCenter(coord);
        this.getLocationCB(coord); //h回显已配置的点位
      } else {
        this.$refs.refAppMap.setMapCenter();
      }
      this.$refs.refAppMap.getAreaInfo();
    },
    getLocationCB(event) {
      let option = [
        {
          id: "point_" + new Date().getTime(),
          coord: [event[0], event[1]],
          src: "images/theme/newDark/map/resource/position_red.png",
          anchor: [10, 20],
        },
      ];
      this.point = [event[0], event[1]];
      this.$refs.refAppMap.removePoint("buildingManage");
      this.$refs.refAppMap.addMarket(option, "buildingManage");
    },
    openMap() {
      this.showMap = true;
      setTimeout(() => {
        this.initMap();
        // this.$map.showMap2D(this.initMap);
      }, 200);
    },
    handleResetPanel() {
      this.checkFirePeople = null;
      this.$refs["ruleForm"].resetFields();
      this.formData.alternatePersonnelList = [];
      this.formData.officePhone = "";
      this.formData.buildingCode = "";
      this.formData.buildingName = "";
      this.formData.buildingPersonnelCode = "";
      this.formData.buildingPersonnelPhone = "";
      this.formData.buildingPersonnelName = "";
      this.formData.lat = "";
      this.formData.lng = "";
      this.formData.mapModelUrl = "";
      this.formData.belongModelUrl = "";
      this.formData.PersonnelList = "";
      this.formData.securityPersonnelList = [];
      this.formData.firefightingPersonnelCode = "";
      this.formData.firefightingPersonnelName = "";
      this.imageUrl = "";
      this.fileList = [];
    },
    imgPath(item) {
      return item ? Bus.imgPath(item.fileCode) : "";
    },
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 批量删除
    batchDelete(data) {
      this.$confirm("此操作将永久删除该数据, 是否继续？", "确认删除", {
        confirmButtonText: this.$t("personMg.button.confirm"),
        cancelButtonText: this.$t("personMg.button.cancel"),
        type: "warning",
      }).then((res) => {
        this.$fetch(api.deleteBuilding, {
          buildingCode: data ? data.buildingCode : this.listCodes, //支持批量
        }).then((res) => {
          if (res.success) {
            this.$message.success("删除成功");
            !data ? (this.listCodes = []) : "";
            this.checkAll = false;
            this.getListData();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    // 删除单个数据
    deleteClick(data) {
      this.batchDelete(data);
    },
    // 取消弹窗
    handleClosePanel() {
      this.showPanel = false;
      this.handleResetPanel();
    },
    detailClick(data) {
      this.$router.push({
        path: "/building/floorM",
        query: {
          code: data.buildingCode,
          name: data.buildingName,
        },
      });
    },
    // 修改名单
    handleUpdate(data, type) {
      this.formState = 2;
      this.handleSwitchPanel();
      this.accountId = data.firefightingAccountNumber;
      this.fileList = data.fileCode ? [{ url: data.fileCode }] : [];
      this.imageUrl = data.fileCode ? this.imgPath(data) : "";
      this.formData.belongModelUrl = data.belongModelUrl;
      this.formData.mapModelUrl = data.mapModelUrl;
      this.formData.buildingCode = data.buildingCode;
      this.formData.buildingName = data.buildingName;
      this.formData.buildingPersonnelCode = data.buildingPersonnelCode;
      this.formData.buildingPersonnelName = data.buildingPersonnelName;
      this.formData.buildingPersonnelPhone = data.buildingPersonnelPhone;
      this.formData.firefightingPersonnelName = data.firefightingNickName;
      this.formData.firefightingPersonnelCode = data.firefightingAccountNumber;
      this.formData.lat = data.lat;
      this.formData.officePhone = data.officePhone;
      this.formData.lng = data.lng;
      this.formData.securityPersonnelList = data.securityPersonnelList.map(
        (el) => {
          return {
            name: el.securityPersonnelName,
            personnelCode: el.securityPersonnelCode,
            phone: el.securityPersonnelPhone,
          };
        }
      );
      this.formData.alternatePersonnelList = data.alternatePersonnelList.map(
        (el) => {
          return {
            name: el.alternatePersonnelName,
            personnelCode: el.alternatePersonnelCode,
            phone: el.alternatePersonnelPhone,
          };
        }
      );
      if (type == "view") {
        // 视图模式
        this.formState = 3;
      }
    },
    handleSwitchPanel(panelName = "showPanel", beforeFun = "handleClosePanel") {
      if (this[panelName]) {
        this[beforeFun] ? this[beforeFun]() : "";
        setTimeout(() => {
          this[panelName] = true;
        }, 600);
      } else {
        this[panelName] = true;
      }
    },
    // 创建楼栋
    handleOpenPanel() {
      this.formState = 1;
      this.handleSwitchPanel();
    },
    //选中触发事件
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.listData.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.listData.length;
    },
    // 请求楼栋数据
    getListData() {
      this.loading = true;
      let params = {
        pageNum: this.pageObj.pageNum,
        pageSize: this.pageObj.pageSize,
        buildingCode: "",
        buildingName: this.filterData.name,
        pageFlag: true,
        buildingType: 1, //1楼栋2楼层
      };
      this.$fetch(api.queryBuildingList, params).then((res) => {
        this.loading = false;
        if (res.success) {
          this.listData = res.returnObj.list;
          this.pageObj.total = res.returnObj.total;
        } else {
          this.listData = [];
          this.$message.error(res.msgContent);
        }
      });
    },
    // 改变页码
    currentChange(e) {
      this.pageObj.pageNum = e;
      this.getListData();
    },
    // 改变pageSize
    sizeChange(e) {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = e;
      this.getListData();
    },

    // 查询
    queryFilter() {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = 10;
      this.getListData();
    },
    // 重置
    resetClick() {
      this.filterData.name = "";
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = 10;
      this.getListData();
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "JPG", "PNG", "JPEG", "BPM"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      return true;
    },
    // 提交添加/修改名单
    submitClick() {
      console.log(this.formData);
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.fileList.length && this.fileList[0].uid) {
            // 单独上传
            let formData = new FormData();
            this.fileList.map((item) => {
              formData.append("files", item.raw);
            });
            let picUrl = [];
            let pictur = "";
            this.$fetch(api.upFile, formData).then((res) => {
              if (res.success) {
                res.returnObj.forEach((item) => {
                  picUrl.push(item.fileId);
                });
                pictur = picUrl.join(",");
                this.submitData(pictur);
              } else {
                this.$message.error(res.msgContent);
              }
            });
          } else {
            if (this.fileList.length) {
              this.submitData(this.fileList[0].url);
            } else {
              this.submitData("");
            }
          }
        }
      });
    },
    submitData(fileCode) {
      this.subBtm = true;
      let params = {
        belongModelUrl: this.formData.belongModelUrl,
        buildingName: this.formData.buildingName,
        buildingPersonnelCode: this.formData.buildingPersonnelCode,
        combustibleGasFileCode: this.formData.combustibleGasFileCode,
        firefightingAccountNumber: this.formData.firefightingPersonnelCode,
        officePhone: this.formData.officePhone,
        alternatePersonnelList: this.formData.alternatePersonnelList.map(
          (el) => {
            return el.personnelCode;
          }
        ),
        desc: "",
        electricalFileCode: this.formData.belongModelUrl,
        fileCode: fileCode,
        lat: this.formData.lat,
        lng: this.formData.lng,
        mapModelUrl: this.formData.mapModelUrl,
        parentCode: "200000001",
        securityPersonnelList: this.formData.securityPersonnelList.map((el) => {
          return el.personnelCode;
        }),
      };
      let url = "";
      this.formState === 1
        ? (url = api.addBuilding)
        : ((url = api.updateBuilding),
          (params.buildingCode = this.formData.buildingCode));
      this.$fetch(url, params).then((res) => {
        this.subBtm = false;
        if (res.success) {
          this.$message.success("操作成功");
          this.getListData();
          this.handleClosePanel();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/Index.scss";
@import "~@src/common/assets/style/mixin";

.ioc-table {
  height: 480px !important;
}

.app-panel {
  .el-form-item {
    width: 100%;
  }

  :deep .el-form-item__content {
    width: calc(100% - 100px);
  }

  :deep .el-upload--picture-card {
    width: 135px;
    height: 135px;
  }

  .imgFile {
    display: flex;
    // width: 148px;
    // height: 148px;
    position: relative;

    &:hover {
      .delete-icon {
        opacity: 1;
      }
    }

    .delete-icon {
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 135px;
      height: 135px;
      border-radius: 6px;
      opacity: 0;
      cursor: pointer;
      background-color: rgba($color: #000000, $alpha: 0.4);
      transition: all 0.2s;
      box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
    }
  }

  :deep .el-upload {
    @include set_theme_color(background-color, left-menu-bg-color);
  }
}

.el-scrollbar {
  width: 100%;
  height: calc(100% - 16px);
  position: absolute;
}

.map-choose {
  position: absolute;
  right: 0px;
  font-size: 18px;
  top: -3px;
}

.list-content {
  width: 100%;

  .list-item {
    width: calc((100% - 48px) / 3);
    position: relative;
    margin-right: 16px;
    border-radius: 5px 5px 5px 5px;
    display: inline-block;
    margin-bottom: 16px;
    @include set_theme_color(background-color, left-menu-bg-color);

    &:hover {
      .footer-content {
        display: flex !important;
      }

      // opacity: 0.8;
      .itemItem {
        // color: #fff !important;
      }
    }

    // margin: 0.25% 0.5% 0.25% 0;
    .imgDiv {
      // border-left: 4px solid rgba(0, 168, 151, 1);
      display: flex;
      align-items: cente;
      height: 190px;

      // @include set_theme_color(background-color, blur-color-content);
      .itemLeft {
        // flex: 2;
        width: 45%;
        min-width: 160px;
        // height: 160px;
        cursor: pointer;
        padding: 16px;

        // @include set_theme_color(background-color, blur-color-content);
        .image {
          width: 100%;
          height: 100%;
        }
      }

      .itemRight {
        // flex: 3;
        overflow: hidden;
        cursor: pointer;
        width: 65%;
        padding: 25px 16px 16px 0;

        // @include set_theme_color(background-color, blur-color-content);
        .footer-content {
          display: none;
          align-items: flex-end;
          position: absolute;
          right: 5px;
          top: 8px;
          -webkit-flex-flow: row-reverse wrap;
          flex-flow: column;
          flex-wrap: wrap;
          justify-content: space-between;

          button {
            margin-top: 12px;
            padding: 5px 13px;
          }
        }

        .itemName {
          font-size: 18px;
          display: grid;
          // width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0px 0 17px 0;

          span {
            width: 88%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          i {
            &:hover {
              @include set_theme_color(color, active-border-color);
            }
          }
        }

        .itemItem {
          display: flex;
          font-size: 14px;
          // color: rgba(162, 173, 203, 1);
          margin-top: 15px;

          img {
            margin-right: 8px;
          }

          label {
            display: block;
            width: 80px;
          }

          span {
            display: block;
            // width: 50%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
